import React, { useState, useEffect } from "react";
import "../syariah/SyariahPage.css";
import api from "../../../services/baseUrl";
import CircularProgress from "@mui/material/CircularProgress";
import Pagination from "../../../components/Pagination";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import CaseLawSearchBox from "../../../components/CaseLawSearchBox";
import SearchTable from "../search-result/SearchTable";
import Modal from "../../eGazette/search/Modal";
import download from "downloadjs";
import HighlightedText from "../../../components/HighlightKeyword";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export default function CivilAndCriminal() {
    const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(false);
  // const [limit, setLimit] = useState(10);
    const pageParam = Number(searchParams.get("page")) || 1; // default 1
    const limitParam = Number(searchParams.get("limit")) || 10;
    const [limit, setLimit] = useState(limitParam);
    const [currentPage, setCurrentPage] = useState(pageParam - 1); // zero-based
    const [itemOffset, setItemOffset] = useState((pageParam - 1) * limit);
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);
  const [documentList, setDocumentList] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const location = useLocation();

  // const [itemOffset, setItemOffset] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  // const [currentPage, setCurrentPage] = useState(0);
  const [totalResult, settotalResults] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [fileUUID, setFileUUID] = useState("");
  const [documentId, setDocumentId] = useState("");
  const queryParam = searchParams.get("query");
    const [query, setQuery] = useState(queryParam);
  const typeParam = searchParams.get("type");
  const courtType = Number(searchParams.get("courtType"));
  const navigate = useNavigate();
  const openModal = async (uuid) => {
    if (uuid) {
      setFileUUID(uuid);
      fetchPdf(uuid);
      setIsModalOpen(true);
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
    setDocumentId("");
  };



  // initialize state from URL


  useEffect(() => {
    const endOffset = itemOffset + limit;
    setCurrentItems(documentList.slice(itemOffset, endOffset));
    console.log(currentItems.length);
    setPageCount(Math.ceil(documentList.length / limit));
    settotalResults(documentList.length);

    const pageNumber = Math.floor(itemOffset / limit);
    setCurrentPage(pageNumber);
  }, [itemOffset, limit, documentList]);

  const handlePageClick = (event) => {
    const selectedPage = event.selected; // zero-based
    const newOffset = selectedPage * limit;

    setItemOffset(newOffset);
    setCurrentPage(selectedPage);

    // update URL params so refresh/back keeps state
    const params = new URLSearchParams(searchParams);
    params.set("page", selectedPage + 1); // one-based for URL
    params.set("limit", limit);
    navigate(`${location.pathname}?${params.toString()}`);

    const syariahBody = document.querySelector(".syariah-body");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
  };
useEffect(() => {
  const fetchDocuments = async () => {
    try {
      setLoading(true);
      if (queryParam) {
        setQuery(queryParam)
        // If query param exists, run search
        const response = await api.post(
          typeParam === "keyword"
            ? "/search/cont/caselaw"
            : "/search/meta/caselaw",
          typeParam === "keyword"
            ? { query: queryParam, courtType: Number(courtType) }
            : {
                query: queryParam,
                type: typeParam,
                courtType: Number(courtType),
              },
          { headers: { "Content-Type": "application/json" } }
        );
        if(typeParam === "keyword"){
          setContent(true);
        }else{
          setContent(false);
        }
        setDocumentList(response.data.results || response.data);
      } else {
        const response = await api.post(
          "/caselaw/default",
          { courtType: Number(courtType) },
          { headers: { "Content-Type": "application/json" } }
        );
        setContent(false);
        setDocumentList(response.data);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchDocuments();
}, [courtType, searchParams]);

  // useEffect(() => {
  //   const endOffset = itemOffset + limit;
  //   setCurrentItems(documentList.slice(itemOffset, endOffset));
  //   setPageCount(Math.ceil(documentList.length / limit));
  //   settotalResults(documentList.length);
  //   const pageNumber = Math.ceil(itemOffset / limit);
  //   setCurrentPage(pageNumber);
  // }, [itemOffset, limit, documentList]);

  // const handlePageClick = (event) => {
  //   const newOffset = (event.selected * limit) % documentList.length;
  //   setItemOffset(newOffset);

  //   const syariahBody = document.querySelector(".syariah-body");
  //   if (syariahBody) {
  //     const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
  //     window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
  //   }
  //   setCurrentPage(event.selected);
  // };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedList = [...documentList].sort((a, b) => {
      const aValue = a[key]?.toLowerCase().trim() || "";
      const bValue = b[key]?.toLowerCase().trim() || "";

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDocumentList(sortedList);
    setSortConfig({ key, direction });
    setItemOffset(0);
    setCurrentPage(0);
  };

  const getArrowIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? (
        <TiArrowSortedUp size={18} className="case-law-arrow-up" />
      ) : (
        <TiArrowSortedDown size={18} className="case-law-arrow-down" />
      );
    } else {
      return <TiArrowUnsorted size={18} />;
    }
  };

const onSearch = (query, type, courtType) => {
  const params = new URLSearchParams({
    query,
    type,
    courtType: String(courtType),
  });

  navigate(`/case-law?${params.toString()}`);
};

  const fetchCaseLawPdf = async (documentID) => {
    setDocumentId(documentID);
    try {
      const response = await api.get("/api/caselaw-documents/fileUUID", {
        params: { documentID: documentID },
        headers: {
          "Content-Type": "application/json",
        },
      });

      setFileUUID(response.data);
      openModal(response.data);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const fetchPdf = async (uuid) => {
    try {
      const response = await api.post(
        "/document/pdf",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const downloadPdf = async (uuid) => {
    try {
      const fileNameEndpoint = "/api/caselaw-documents/getFileName";
      const fileNameResponse = await api.post(
        fileNameEndpoint,
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const fileNameText = await fileNameResponse.data;
      const fileName = fileNameText.split("/").pop();

      const response = await api.post(
        "/document/pdf/download",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      download(response.data, fileName, contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  return (
    <>
      <div
        className="case-law disclaimer"
        style={{
          padding: "10px 100px",
          fontSize: "12px",
          textAlign: "justify",
          color: "#FF2C2C",
        }}
      >
        Disclaimer: This case law module is currently in the development phase
        and may contain incomplete or evolving content. While we strive for
        accuracy, the information provided is for reference purposes only and
        should not be considered legal advice or used as an official court
        reference. Users are encouraged to verify details from Lawnet before
        making any decisions based on this module.
      </div>
      <div className="syariah-body">
        <CaseLawSearchBox
          onSearch={onSearch}
          placeholder={"Enter keyword to search"}
          limit={limit}
          setLimit={setLimit}
          courtType={1}
          query={query}
        />
      </div>

      <div className="egazette-content">
        {!loading ? (
          !content ? (
            <table className="case-law-table">
              <thead>
                <tr>
                  <th
                    style={{ minWidth: "12vw" }}
                    onClick={() => handleSort("decisionDate")}
                  >
                    <div className="case-law-table-header">
                      Judgment Date {getArrowIcon("decisionDate")}
                    </div>
                  </th>
                  <th
                    style={{ minWidth: "20vw" }}
                    onClick={() => handleSort("caseTitle")}
                  >
                    <div className="case-law-table-header">
                      Case Title {getArrowIcon("caseTitle")}
                    </div>
                  </th>
                  <th
                    style={{ minWidth: "10vw" }}
                    onClick={() => handleSort("courtName")}
                  >
                    <div className="case-law-table-header">
                      Court {getArrowIcon("courtName")}
                    </div>
                  </th>
                  <th
                    style={{ minWidth: "15vw" }}
                    onClick={() => handleSort("keyword")}
                  >
                    <div className="case-law-table-header">
                      Subject Matter {getArrowIcon("keyword")}
                    </div>
                  </th>
                  <th
                    style={{ minWidth: "15vw" }}
                    onClick={() => handleSort("judgeName")}
                  >
                    <div className="case-law-table-header">
                      Judge(s) {getArrowIcon("judgeName")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item) => (
                  <tr key={item?.id}>
                    <td>
                      {new Date(item?.decisionDate).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )}
                    </td>
                    <td>
                      <p
                        style={{ color: "blue" }}
                        className="case-law-clickable"
                        onClick={() => {
                          fetchCaseLawPdf(item?.documentId);
                        }}
                      >
                        <HighlightedText
                          paragraph={item?.caseTitle}
                          keyword={query}
                          onClick={() => {
                            fetchCaseLawPdf(item.documentId);
                          }}
                        />
                      </p>
                    </td>
                    <td>
                      <HighlightedText
                        paragraph={`${item?.courtName} (${item?.courtLocation})`}
                        keyword={query}
                      />
                    </td>
                    <td>
                      <HighlightedText
                        paragraph={item?.keyword}
                        keyword={query}
                      />
                    </td>
                    <td>{item?.judgeName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : currentItems.length > 0 ? (
            <div style={{ marginBottom: "30px" }}>
              {currentItems && currentItems?.map((document, index) => (
                <SearchTable
                  key={index}
                  tableIndex={index}
                  activeDropdownIndex={activeDropdownIndex}
                  setActiveDropdownIndex={setActiveDropdownIndex}
                  caseLawDocument={document}
                  query={query}
                />
              ))}
              </div>
          ) : (
            
                <div style={{ margin: "25px" }}>No results found</div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        keyword={query}
        pdf={file}
        pageNumber={1}
        fileUUID={fileUUID}
        downloadPdf={(uuid) => downloadPdf(uuid)}
        documentId={documentId}
      />
      {!content && (
        <Pagination
          handlePageClick={handlePageClick}
          pageCount={pageCount}
          currentPageNumber={currentPage}
          totalResult={totalResult}
          limit={limit}
          offset={itemOffset}
        />
      )}
    </>
  );
}
